enum SubscriptionsActions {
    FETCH_LIST = "subscriptionsFetchList",
    GET_ITEM = "subscriptionsGetItem",
    CREATE_ITEM = "subscriptionsCreateItem",
    UPDATE_ITEM = "subscriptionsUpdateItem",
    DELETE_ITEM = "subscriptionsDeleteItem",
    REFRESH_LIST = "subscriptionsRefreshList",
    UPDATE_TRANSLATION = "subscriptionsUpdateTranslation",
    FETCH_MEMBERS = "subscriptionsFetchMembers",
    CANCEL_MEMBER = "subscriptionsCancelMember",
    CLOSE_MEMBER = "subscriptionsCloseMember",
    CONFIRM_MEMBER = "subscriptionsConfirmMember",
    FETCH_PACKAGE_GROUPS = "subscriptionsFetchPackageGroups",
    CREATE_PACKAGE_GROUP = "subscriptionsCreatePackageGroup",
    UPDATE_PACKAGE_GROUP = "subscriptionsUpdatePackageGroup",
    DELETE_PACKAGE_GROUP = "subscriptionsDeletePackageGroup",
    SORT_PACKAGE_GROUPS = "subscriptionsSortPackageGroups",
    FETCH_FILES = "subscriptionsFetchFiles",
    GET_FILE = "subscriptionsGetFile",
    ADD_FILE = "subscriptionsAddFile",
    UPDATE_FILE = "subscriptionsUpdateFile",
    DELETE_FILE = "subscriptionsDeleteFile",
    FETCH_COURSE_EXPERTISES = "subscriptionsFetchCourseExpertises",
    FETCH_ALL_PACKAGES = "subscriptionsFetchAllPackages",
    SEND_MAIL = "subscriptionsSendMail",
    CREATE_INVOICE = "subscriptionsCreateInvoice",
    DOWNLOAD_INVOICE = "subscriptionsDownloadInvoice",
    DECLINE_MEMBER = "subscriptionsDeclineMember",
    FETCH_ABOS = "subscriptionsFetchAbos",
    FETCH_DASHBOARD = "subscriptionsFetchDashboard",
    GET_MAIL_TEMPLATE = "subscriptionsGetMailTemplate",
    UPLOAD_PREVIEW_IMAGE = "subscriptionsUploadPreviewImage",
    DELETE_PREVIEW_IMAGE = "subscriptionsDeletePreviewImage",
    UPLOAD_FILE_CONTENT = "subscriptionsUploadFileContent",
    FETCH_PACKAGE_GROUPS_SORTED = "subscriptionsFetchPackageGroupsSorted",
}

enum SubscriptionsMutation {
    SET_RENDER_UPDATE = "subscriptionsListRenderNeeded",
    SET_LIST_RESULT = "subscriptionsListResult"
}

export {SubscriptionsActions, SubscriptionsMutation};
